module.exports = __webpack_public_path__ + "static/media/p2008vid5.e45dd9d9.mp4";